export const constructStrRep = (obj) => {
  return obj.str_representation;
};

export const detailUrl = ({ id }) => {
  return `/rental-notifications/invoicing-objects/projects/${id}`;
};
